/**
 * Hauler Mode (Erhverv) top-level routing map - list keys only.
 *
 * THE hand-maintained source of truth for the module's tab paths
 * (mirrors `route-studio.tsx`). The page registry
 * (`src/modules/hauler-mode/routing/registry.tsx`) derives its routes
 * from `HAULER_MODE_PAGES`; an `AssertKeysInMap` guard there fails
 * `ts:check` if a registry key has no matching key here, so the two
 * cannot drift.
 *
 * S2-F1 (D-E9, the max-4-destinations law): four destinations -
 * Kunder, Ordrer (with the dispatch board as a subview), Containere,
 * Fakturering (with dokumentation as a subview). The two S1 tab paths
 * that folded in ('dispatch', 'compliance') stay in the map as
 * LEGACY REDIRECT-ONLY keys: their URLs live in browser histories and
 * demo scripts, so the module routing replaces them onto their new
 * homes (never a dead link). They are NOT in `PageKey` and never
 * render as tabs.
 *
 * URL segments are the Danish tab words on purpose (they ARE the
 * product's words here); titles/breadcrumbs are English source
 * strings translated via the module's da catalog (S2-F1 i18n
 * decision - route-studio SBX-532 pattern).
 */
import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

export const createHaulerModeRoutesMap = (prefix: string) => ({
  // The business-customer register - the module's landing tab.
  kunder: pathJoin(prefix)('kunder').chainWithTitle({
    title: <T _str="Customers" />,
    breadCrumbTitle: <T _str="Customers" />,
  }),
  // Order intake and order life-cycle (bestilling -> faktura),
  // including the read-only dispatch board subview (?visning=dispatch).
  ordrer: pathJoin(prefix)('ordrer').chainWithTitle({
    title: <T _str="Orders" />,
    breadCrumbTitle: <T _str="Orders" />,
  }),
  // Containers out at customers vs home in the yard.
  containere: pathJoin(prefix)('containere').chainWithTitle({
    title: <T _str="Containers" />,
    breadCrumbTitle: <T _str="Containers" />,
  }),
  // B2B invoices and billable events, including the dokumentation
  // subview (weigh slips, declarations; ?visning=dokumentation).
  fakturering: pathJoin(prefix)('fakturering').chainWithTitle({
    title: <T _str="Invoicing" />,
    breadCrumbTitle: <T _str="Invoicing" />,
  }),
  // LEGACY (S1 tab, folded into Ordrer by S2-F1): redirect-only path.
  dispatch: pathJoin(prefix)('dispatch').chainWithTitle({
    title: <T _str="Orders" />,
    breadCrumbTitle: <T _str="Orders" />,
  }),
  // LEGACY (S1 tab, folded into Fakturering by S2-F1): redirect-only path.
  compliance: pathJoin(prefix)('compliance').chainWithTitle({
    title: <T _str="Invoicing" />,
    breadCrumbTitle: <T _str="Invoicing" />,
  }),
})
